import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'mig-bootstrap-theme';
import React from 'react';
import ReactDOM from 'react-dom';
import './typescript/index.css';
import App from './typescript/App'
import * as serviceWorker from './typescript/serviceWorker';
import {Provider} from 'react-redux';
import {store} from './typescript/store';
import {I18nextProvider} from 'react-i18next';
import i18n from './typescript/translations';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
              <Routes>
                  <Route path="*" element={<App/>} />
              </Routes>
          </BrowserRouter>
        </I18nextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();